import { Injectable, Signal, inject } from '@angular/core';
import { CaseAuthorizationState } from '../../states/case-authorization.state';

/**
 * Use case for reading the current user's case dashboard view type.
 * Returns the signal itself so callers can react to authorization loading,
 * which resolves after the first render. Emits null until state is loaded.
 */
@Injectable({ providedIn: 'root' })
export class GetCaseDashboardViewTypeUseCase {
  private readonly _state = inject(CaseAuthorizationState);

  public execute(): Signal<string | null> {
    return this._state.dashboardViewTypeName;
  }
}
